import { render } from "./Users.vue?vue&type=template&id=a0767d7c&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=a0767d7c&scoped=true&lang=scss"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0767d7c"]])

export default __exports__